import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import moment from "moment";
import IconBox from "@/components/IconBox.vue";
import IconBoxContent from "@/components/IconBoxContent.vue";
import WhiteBox from "@/components/WhiteBox.vue";
import Modal from "@/components/Modal.vue";
import ErrorHandler from "../../classes/errorHandler";
let Tariffs = class Tariffs extends Vue {
    loadTariffs() {
        //this.$store.dispatch("getAdminTariffs");
    }
    editTariff(tariff) {
        this.$data.modals.editTariff = true;
        this.$data.selectedTariffData = tariff;
        if (this.$data.selectedTariffData.fixedHours === -1) {
            this.$data.selectedTariffData.fixedHours = "";
        }
    }
    showCreateDialog() {
        this.$data.createTariffData = {
            name: "",
            rate: 0,
            customerName: "",
        };
        this.$data.modals.createTariff = true;
    }
    updateTariff() {
        delete this.$data.selectedTariffData.absence;
        delete this.$data.selectedTariffData.billable;
        this.$store
            .dispatch("updateAdminTariffAsync", this.$data.selectedTariffData)
            .then(() => {
            this.$store.dispatch("loadGlobalTariffsAsync").then((response) => {
                this.$store.commit("setGlobalTariffs", response.data);
                this.$store.dispatch("ToastMessage", {
                    type: "any",
                    message: "Tariff updated",
                });
                this.$data.modals.editTariff = false;
            });
        })
            .catch((err) => {
            this.$data.errorHandler.logError(err, "updateTariff");
        });
    }
    createTariff() {
        this.$store
            .dispatch("createAdminTariffAsync", this.$data.createTariffData)
            .then(() => {
            this.$store.dispatch("loadGlobalTariffsAsync").then((response) => {
                this.$store.commit("setGlobalTariffs", response.data);
                this.$data.modals.createTariff = false;
                this.$store.dispatch("ToastMessage", {
                    type: "any",
                    message: "Tariff Created",
                });
            });
        })
            .catch((err) => {
            this.$data.errorHandler.logError(err, "createAdminTariffAsync");
        });
    }
    isCurrentEmployee(employee) {
        return (moment(new Date()) <= moment(employee.endOfEmployment) ||
            employee.endOfEmployment === null);
    }
};
Tariffs = __decorate([
    Component({
        data() {
            return {
                errorHandler: new ErrorHandler(),
                theme: this.$store.getters.getTheme,
                tariffHeaders: [
                    { text: "Customer", value: "customerName" },
                    { text: "Name", value: "name" },
                    { text: "Type", value: "type" },
                    { text: "Rate", value: "rate" },
                    { text: "Edit", value: "edit", sortable: false },
                    { text: "Members", value: "id", sortable: false },
                ],
                tariffTypes: [
                    "Internal",
                    "Stack",
                    "Billable",
                    "Vacation",
                    "AbsenceShortTerm",
                    "AbsenceLongTerm",
                    "OnCall",
                ],
                //[{key:'customerName', sortable:true}, {key: 'name', sortable: true,}, {key: 'billable',sortable:true}, {key:'rate', sortable:true},
                //{key:'notWorking', sortable:true},{key:'edit', sortable:false}]
                selectedTariffData: null,
                selectedMembersTariff: null,
                createTariffData: {
                    name: null,
                    rate: null,
                    customerName: null,
                },
                modals: {
                    editTariff: false,
                    createTariff: false,
                    membersTariff: false,
                },
                tariffs: null,
                employees: null,
                loadingEmployeeTariffs: true,
                sortbyValue: "name",
                filter: "",
                fields: [
                    {
                        key: "name",
                        sortable: true,
                    },
                    {
                        key: "tariffs",
                    },
                ],
            };
        },
        computed: {
            membersTariff() {
                return this.$data.modals.membersTariff;
            },
            membersInSelectedTariff() {
                if (this.$data.selectedMembersTariff === null) {
                    return [];
                }
                const members = this.$data.employees.filter((employee) => {
                    if (!Array.isArray(employee.tariffs)) {
                        return false;
                    }
                    const allEmployeeTariffs = employee.tariffs.map((t) => t.id);
                    return allEmployeeTariffs.includes(this.$data.selectedMembersTariff.id);
                });
                return members;
            },
        },
        watch: {
            membersTariff() {
                if (this.$data.membersTariff === false) {
                    this.$data.selectedMembersTariff = null;
                }
            },
        },
        async mounted() {
            this.$data.loadingEmployeeTariffs = true;
            this.$data.tariffs = await this.$store.dispatch("getAdminTariffs");
            const employees = (await this.$store.dispatch("adminLoadEmployees")).data;
            const employeesWithTariffs = await Promise.all(employees.map(async (emp) => {
                const tariffs = (await this.$store.dispatch("adminGetUserTariffsAsync", emp.userId)).data;
                emp.tariffs = tariffs;
                return emp;
            }));
            this.$data.employees = employeesWithTariffs;
            this.$data.loadingEmployeeTariffs = false;
        },
        components: {
            IconBox,
            IconBoxContent,
            WhiteBox,
            Modal,
        },
    })
], Tariffs);
export default Tariffs;
